import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    newlyCreatedCustomer: null
};

const customerSelectionSlice = createSlice({
    name: 'customerSelection',
    initialState,
    reducers: {
        setNewlyCreatedCustomer: (state, action) => {
            state.newlyCreatedCustomer = action.payload;
        },
        clearNewlyCreatedCustomer: (state) => {
            state.newlyCreatedCustomer = null;
        }
    }
});

export const { 
    setNewlyCreatedCustomer, 
    clearNewlyCreatedCustomer
} = customerSelectionSlice.actions;

// Selectors
export const selectNewlyCreatedCustomer = (state) => state.customerSelection.newlyCreatedCustomer;

export default customerSelectionSlice.reducer;
